// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RelayEnv = require("../../../RelayEnv.bs.js");
var DebounceP = require("../../../reason/common/DebounceP.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
var AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
var Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var SelectInputTextSize = require("../../common/Form/SelectInputTextSize.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var CityZipAutocompleteV5Query_graphql = require("../../../__generated__/CityZipAutocompleteV5Query_graphql.bs.js");
var CityZipAutocompleteV5_result_graphql = require("../../../__generated__/CityZipAutocompleteV5_result_graphql.bs.js");

var getConnectionNodes = CityZipAutocompleteV5_result_graphql.Utils.getConnectionNodes;

var convertFragment = CityZipAutocompleteV5_result_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, CityZipAutocompleteV5_result_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(CityZipAutocompleteV5_result_graphql.node, convertFragment, fRef);
}

var Fragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

var convertVariables = CityZipAutocompleteV5Query_graphql.Internal.convertVariables;

var convertResponse = CityZipAutocompleteV5Query_graphql.Internal.convertResponse;

var convertWrapRawResponse = CityZipAutocompleteV5Query_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, CityZipAutocompleteV5Query_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, CityZipAutocompleteV5Query_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(CityZipAutocompleteV5Query_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(CityZipAutocompleteV5Query_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(CityZipAutocompleteV5Query_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(CityZipAutocompleteV5Query_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function getOptionValue(param) {
  return param.id;
}

function getOptionLabel(param) {
  return param.label;
}

var Area = {
  getOptionValue: getOptionValue,
  getOptionLabel: getOptionLabel
};

function trimInput(s) {
  return (function (__x) {
                return __x.replace(/\s+/g, " ");
              })((function (__x) {
                    return __x.replace(/[^\w\s]/g, " ");
                  })(s)).trim();
}

function queryFn(searchTerm) {
  return ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
                      searchTerm: searchTerm
                    }, undefined, undefined)), (function (v) {
                if (v.TAG !== "Ok") {
                  return {
                          TAG: "Error",
                          _0: {
                            NAME: "REJECTED",
                            VAL: v._0
                          }
                        };
                }
                var r = v._0.cityZipAutocompleteV5;
                if (r === undefined) {
                  return {
                          TAG: "Error",
                          _0: "EMPTY_RESULT"
                        };
                }
                var response = readInline(r.fragmentRefs);
                var areas = getConnectionNodes(response.areas);
                return {
                        TAG: "Ok",
                        _0: areas.map(function (param) {
                              return {
                                      id: param.id,
                                      label: param.label
                                    };
                            })
                      };
              }));
}

function CityZipAutocompleteV5(props) {
  var status = props.status;
  var onChange = props.onChange;
  var value = props.value;
  var queryFn$1 = DebounceP.make(300, (function (input) {
          return Utils__Promise.toJsPromise(queryFn(input));
        }));
  var defaultOpts;
  if (value !== undefined) {
    var value$1 = Caml_option.valFromOption(value);
    defaultOpts = value$1 !== undefined ? [value$1] : [];
  } else {
    defaultOpts = [];
  }
  var value$2;
  if (value !== undefined) {
    var value$3 = Caml_option.valFromOption(value);
    value$2 = value$3 !== undefined ? value$3 : undefined;
  } else {
    value$2 = undefined;
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(AutocompleteV5.AsyncSelect.Single.make, {
                    getOptionLabel: getOptionLabel,
                    getOptionValue: getOptionValue,
                    isClearable: true,
                    loadOptions: (function (v) {
                        var v$1 = trimInput(v);
                        if (v$1.length < 2) {
                          return Promise.resolve(defaultOpts);
                        } else {
                          return queryFn$1(trimInput(v$1));
                        }
                      }),
                    onBlur: props.onBlur,
                    onFocus: props.onFocus,
                    onChange: (function (value) {
                        if (onChange !== undefined) {
                          return onChange(value);
                        }
                        
                      }),
                    noOptionsMessage: (function (v) {
                        return v.length < 2 ? "Type at least two characters" : "No locations match \"" + v + "\"";
                      }),
                    placeholder: "Please enter a city or a zip code",
                    status: status !== undefined ? (
                        status === "ok" ? "Success" : "Failure"
                      ) : "Neutral",
                    value: value$2
                  }),
              className: SelectInputTextSize.className
            });
}

var make = CityZipAutocompleteV5;

exports.Fragment = Fragment;
exports.Query = Query;
exports.Area = Area;
exports.trimInput = trimInput;
exports.queryFn = queryFn;
exports.make = make;
/* use Not a pure module */
